import { MessageSquare, AlertCircle } from 'lucide-react';
import { useTravellerFeedback } from '../../../../context/travellerFeedback/TravellerFeedbackContext';
import { feedbackData } from '../../utils/feedbackHelpers';
import FeedbackCard from './sections/FeedbackCard/FeedbackCard';

const FeedbackList = () => {
  const { feedbacks, error } = useTravellerFeedback();

  return (
    <div className="space-y-4">
      {error && (
        <div className="bg-red-50 text-red-700 p-4 rounded-xl flex items-center gap-2 text-sm border border-red-100">
          <AlertCircle size={18} className="flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}

      {!feedbacks || feedbacks.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 text-center border border-slate-100 shadow-xs">
          <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-400">
            <MessageSquare size={32} />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">{feedbackData.emptyState.title}</h3>
          <p className="text-gray-500 mt-2 text-sm">{feedbackData.emptyState.description}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {feedbacks.map((feedback) => (
            <FeedbackCard key={feedback._id || feedback.id} feedback={feedback} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FeedbackList;
